import { useEffect } from 'react';

import { Box } from '@opendoor/bricks-next';
import { LocalizationProvider } from '@opendoor/cinderblocks/growth/auth/LocalizationContext';
import ResetPasswordForm from '@opendoor/cinderblocks/platform/auth/ResetPasswordForm';
import { analytics, globalObservability } from '@opendoor/observability/slim';
import Cookies from 'js-cookie';

import { useLocale } from 'helpers/useLocale';

import ResetPasswordConnector, { ResetPasswordProps } from '../shared/ResetPasswordConnector';

const Sentry = globalObservability.getSentryClient();

const UNAUTHORIZED_STATUS_CODE = 401;

interface IResetPasswordFormPageProps extends ResetPasswordProps {
  redirectTo?: string | undefined;
}

const ResetPasswordFormPage: React.FC<IResetPasswordFormPageProps> = ({
  resetPasswordRequestStatus,
  requestPasswordReset,
  hasGeneratedPassword,
  email,
  redirectTo,
  isNewHuman = false,
}) => {
  const locale = useLocale();

  useEffect(() => {
    analytics.register({ 'reset-password': Cookies.get('reset-password-test') || 'no-cookie' });
    analytics.trackEvent('reset-password', 'load', undefined, { email, redirectTo });
  }, []);

  useEffect(() => {
    if (
      resetPasswordRequestStatus &&
      resetPasswordRequestStatus.error &&
      resetPasswordRequestStatus.statusCode !== UNAUTHORIZED_STATUS_CODE
    ) {
      Sentry.captureException?.(resetPasswordRequestStatus.error);
    }
  }, [resetPasswordRequestStatus]);

  return (
    <Box
      px="$12x"
      py="$24x"
      maxWidth={480}
      width="100%"
      mx="auto"
      $largerThanSM={{
        py: '$36x',
        px: 0,
      }}
      alignItems="center"
    >
      <LocalizationProvider locale={locale}>
        <ResetPasswordForm
          email={email}
          hasGeneratedPassword={hasGeneratedPassword}
          error={resetPasswordRequestStatus.error}
          loading={resetPasswordRequestStatus.isLoading}
          isNewHuman={isNewHuman}
          onRequestResetPassword={requestPasswordReset}
          onPasswordResetSuccess={() => window.location.assign('/login')}
          analyticsName="cosmos-reset-password-form"
        />
      </LocalizationProvider>
    </Box>
  );
};
export default ResetPasswordConnector(ResetPasswordFormPage);
